import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './ImageSlider.css'
import image1 from './images/img1.png';
import image2 from './images/img2.jpg';
import image3 from './images/img3.jpg';



const ImageSlider = () => {
  return (
    <div className='container my-5'>
    <h2 className='d-flex align-items-center justify-content-center font-weight-bold  my-5'>Hilights</h2>
    <div className='bg-dark'>
          <Carousel autoPlay infiniteLoop showThumbs={false} interval={4000} stopOnHover={false}  >
      
    
      <div className='container     '>
    
        <img className='img p-2 object-fit-cover  rounded p-5' src={image1} alt={'image1'} />
        
      </div>
      
      <div className='container '>
        <img className='img p-2 object-fit-contain  rounded p-5 'src={image2} alt={'Image2'} />
        
      </div>
      
      <div className='container  '>
        <img className='img p-2 object-fit-contain boder rounded  p-5' src={image3} alt={"Image3"} />
      
      </div>
      
    </Carousel>
    
    </div>
    </div>
    
  );
};

export default ImageSlider;
